import React, { useContext, useState } from 'react'
import { TakePhoto } from '../../../../../../components/TakePhoto'
import { AlertMessage } from '../../../../../../components/AlertMessage'
import { Image } from 'react-native'
import { NecropsyContext } from '../../../../../../context/Necropsy/Provider'
import { useTranslation } from 'react-i18next'

interface Props {
  onClose: () => void
}

export const AditionalPhoto = ({ onClose }: Props) => {
  const { setAditionalPhoto } = useContext(NecropsyContext)
  const { t } = useTranslation()
  const [showAlert, setShowAlert] = useState(false)
  const [photo, setPhoto] = useState('')

  return (
    <>
      {!showAlert && (
        <TakePhoto
          getPhoto={(uri) => {
            setPhoto(uri)
            setShowAlert(true)
          }}
          capturingText={t('FOTO ADICIONAL')}
          indicationsText={t('Sitúe el pescado completo dentro del margen')}
        />
      )}
      {showAlert && (
        <AlertMessage
          title={t('Foto tomada con éxito')}
          cancelLabel={t('Repetir foto')}
          successLabel={t('Continuar')}
          action={() => {
            setShowAlert(false)
            onClose()
            setAditionalPhoto({ uri: photo })
          }}
          cancelButton
          actionCancelButton={() => {
            setShowAlert(false)
            setPhoto('')
          }}
        >
          <Image
            source={{ uri: photo }}
            style={{ width: '100%', height: 500, borderRadius: 8 }}
            resizeMode='cover'
          />
        </AlertMessage>
      )}
    </>
  )
}
